module.exports = "<div id=\"extr-page\">\r\n<router-outlet></router-outlet>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/layout/app-layouts/auth-layout.component.html
// module id = ../../../../../src/app/shared/layout/app-layouts/auth-layout.component.html
// module chunks = main